import * as React from 'react';
import cn from '~modules/cn';

import './checkbox.scss';

export type CheckboxType = 'negative';

type Props = {
    type?: CheckboxType;
    className?: string;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
const Checkbox = React.forwardRef<HTMLInputElement, Props>(
    ({ type, className, ...rest }, ref): JSX.Element => (
        <input {...rest} type="checkbox" ref={ref} className={cn('checkbox-input', { [`checkbox-input--${type}`]: Boolean(type) }, className)} />
    )
);
Checkbox.displayName = 'Checkbox';

export default Checkbox;
